import request from "../utils/request";

export async function createJob(data) {
  const res = await request({
    url: "/department/create_job",
    data,
    method: "post",
  });

  return res;
}

export async function getJobList(data) {
  const res = await request({
    url: "/department/job_detail_list",
    data,
    method: "post",
  });
  return res;
}

export async function deleteJob(id) {
  const res = await request({
    url: "/department/delete_job?role_id=" + id,
    //params: params,
    method: "get",
  });
  return res;
}

export async function editJob(data) {
  const res = await request({
    url: "/department/edit_job",
    data,
    method: "post",
  });
  return res;
}


export async function addDepart(data) {
  const res = await request({
    url: "/department/create_department",
    data,
    method: "post",
  });
  return res;
}

export function getBaseUrl() {
  return request.defaults.baseURL;
}
